import { web } from "../config/System";

export const translationEn = {
  "guest.layout": {
    "login.title": `Welcome to the ${web.univAcronym} Admission Login Page!`,
    "login.header": `Login to the ${web.univAcronym} Admission System`,
    "login.description": "Enter your account credentials to access the system.",
    "login.reset-password": "Request/Forgot Password?",
    "login.new-account": "Don't have an account? Sign up/Register here",
    "register.title": `Welcome to the ${web.univAcronym} Admission Account Registration Page!`,
    "register.description": "Official Admissions Portal for New Students",
    "register.header": "Account Registration",
    "register.header.title": "Warning!",
    "register.header.description":
      "Important: *SNBP and SNBT graduates _do not need to create an account_*. This registration is only for creating a system account and is not the official new student enrollment process. If you already have an account, please log in directly.",
    "register.step-1": "Account Registration",
    "register.step-2": "Personal Information",
    "register.label.nama-lengkap": "Full Name (Without Title)",
    "register.label.konfirmasi-password": "Confirm Password",
    "register.send": "Send Verification Email",
    "register.submit": "Submit Registration Data",
    "register.has-account": "Already have an account? Login here.",
    "register.sent.title": "Thank you for registering!",
    "register.sent.description-1":
      "We have sent a verification link to your email",
    "register.sent.description-2":
      "Please check your inbox and follow the steps to verify your account. If you don't see the email, check your spam or promotions folder. Haven’t received the email?",
    "register.sent.resend": "Click here to resend.",
    "register.label.kewarganegaraan": "Citizenship",
    "register.label.handphone": "Phone Number / WhatsApp",
    "register.label.handphone.description":
      "Make sure to use an active number connected to WhatsApp",
    "register.label.alamat": "Address",
    "register.success.title": "Your Registration Was Successful",
    "register.success.description":
      "Thank you for completing the registration process. Your data has been successfully saved, and we are excited to welcome you as a prospective new student. Let's move forward to the next step!",
    "button.send-reset-passsowrd-request": "Send Password Reset Request",
    "button.resend-reset-passsowrd-request": "Resend",
    "link.go-to-login": "Go to Login Page",
    "help.title": "Need Help?",
    "help.description": `If you experience any issues using SPMB ${web.univAcronym}, you can contact the UPA-TIK ${web.univAcronym} Helpdesk via the following WhatsApp number:`,
    "notif.email-sent.1":
      "We have sent the password reset request to your email address.",
    "notif.email-sent.2": "Please check your email inbox.",
    "button.back": "Back",
    "forgot-password.title": "Request / Reset Password",
    "forgot-password.description":
      "Enter your registered email address. We will send you a link to reset your password.",
    "forgot-password.notice.title":
      "For National Selection (SNBP & SNBT) Successful Applicants Only",
    "forgot-password.notice.description":
      "You <strong>are required</strong> to request a password for your first login. Make sure to use the <strong>email registered at the Central SNPMB</strong>.",
    "forgot-password.label.email": "Registered Email",
    "forgot-password.button.processing": "Processing...",
    "forgot-password.button.wait": "Wait {{count}} seconds...",
    "forgot-password.sent.info": "Sent to:",
    "forgot-password.sent.description":
      "Please check your email inbox for password reset instructions.",
    "forgot-password.button.back-login": "Back to Login",
    "reset-password.title": "Set New Password",
    "reset-password.description":
      "Create a new secure password for your account.",
    "reset-password.label.password": "New Password",
    "reset-password.label.confirm-password": "Confirm Password",
    "reset-password.placeholder.password": "Minimum 8 characters",
    "reset-password.placeholder.confirm-password": "Retype password",
    "reset-password.strength.label": "Password Strength:",
    "reset-password.strength.weak": "Weak",
    "reset-password.strength.medium": "Medium",
    "reset-password.strength.strong": "Strong",
    "reset-password.button.submit": "Save Password",
    "reset-password.success.title": "Password Successfully Changed!",
    "reset-password.success.description":
      "Your password has been successfully reset. You will be redirected to the login page in 3 seconds...",
    "reset-password.success.button": "Login Now",
    "reset-password.link.back": "Back to Login",
  },
  "siswa.layout": {
    "dashboard.title": "Hello",
    "dashboard.description": `Welcome to the ${web.univAcronym} Admission System at Universitas Pendidikan Ganesha. This system is designed to simplify the registration process for new prospective students and re-registration. Please make sure to choose the appropriate admission path from the available options.`,
    "dashboard.search": "Search by admission path/period name...",
    "dashboard.search.result.label": "Search Results",
    "dashboard.search.result.delete": "Clear Search",
    "dashboard.search.result.notfound": "Registration path not found!",
    "dashboard.periode.tips":
      "Tip: Scroll down to see the available registration periods",
    "dashboard.periode.text":
      "Please select one of the available registration periods below.",
    "dashboard.periode.type-kerjasama": "PARTNERSHIP",
    "dashboard.periode.program.title": "Available Programs",
    "dashboard.periode.action.pilih": "Select This Track",
    "dashboard.periode.action.lihat": "View Results",
    "register.title": "Registration",
    "register.label.nama-lengkap": "Full Name (Without Title)",
    "register.label.nama-lengkap.description":
      "Full name must match your latest diploma, without any titles!",
    "register.label.tahun-kelulusan": "Year of Graduation",
    "register.label.jenjang": "Program Level You Are Applying For",
    "register.label.prodi": "Program You Are Applying To",
    "register.label.birthdate": "Date of Birth",
    "register.button.daftar": "Register Now",
    "register.button.batal": "Cancel/Close",
    "register.confirmation.title":
      "Are you sure you want to register for the admission path",
    "register.confirmation.button": "Yes, Register Now",
    "register.confirmation.check":
      "I HEREBY DECLARE THAT ALL INFORMATION I HAVE PROVIDED IS TRUE AND ACCURATE.",
    "step.title.warning": "Warning!",
    "step.description.sebelumnya": "previous",
    "step.description.warning":
      "not completed yet! Cannot proceed to the next step.",
    "button.close": "Close/Cancel",
  },
  alert: {
    "announcement.admission.title": "Admission Announcement",
    "announcement.passed":
      "Congratulations {{nama_lengkap}} | {{nomor_pendaftaran}}, you have been accepted into the {{prodi_nama}} study program",
    "announcement.not-passed":
      "We regret to inform you {{nama_lengkap}} | {{nomor_pendaftaran}} that you were not accepted into the {{prodi_nama}} study program.",
    "announcement.ukt.title": "UKT Announcement",
  },
  ukt: {
    "announcement.alert.payment": "UKT Payment",
    "announcement.alert.provision": `Failure to complete payment by the specified deadline will be considered as withdrawing from ${web.univAcronym}.`,
    "announcement.alert.procedur":
      'After payment/confirmation, please print your NIM by clicking the "Download" button.',
    "announcement.title": "Amount of Single Tuition Fee (UKT)",
    "announcement.ipi": "Institutional Development Fee (IDF)",
    "announcement.total": "Total Payment",
    "announcement.determination":
      "The UKT determination result has not been decided yet.",
    "button.unpaid.invoice": "Generate Invoice",
    "button.unpaid.invoice.regenerate": "Regenerate Invoice",
    "button.unpaid.payment.view": "View Invoice",
    "button.paid.payment.view": "View Payment",
    "payment.text": "Payment",
    "payment.status-1": "Unpaid",
    "payment.status-2": "Paid",
    "payment.status-3": "Deleted/Expired",
    "payment.status-4": "Paid (Deferred)",
    "payment.status-5": "Scholarship",
    "card.title.1": "Generate Invoice",
    "card.title.2": "Print Invoice",
    "card.title.3": "Print Student ID (NIM)",
    "card.description.1":
      "This feature is used to generate a student payment invoice through the selected payment method. The invoice contains detailed payment information such as the amount to be paid, payment code, and other related details.",
    "card.description.2":
      "This feature is used to print a student payment invoice through the selected payment method. The invoice contains detailed payment information such as the amount to be paid, payment code, and other related details.",
    "card.description.3":
      "This feature allows students to print a document containing their Student Identification Number (NIM). The document serves as the student's official identity in the academic system. A 'Download' button is available to download the file in PDF format.",
  },
  dataPendaftaran: {
    "nomor-pendaftaran": "Registration Number",
  },
  dataSiswa: {
    "nama-lengkap": "Full Name",
  },
  dataPilihanProdi: {
    prodi: "Study Program",
    jurusan: "Department",
    fakultas: "Faculty",
  },
  invoice: {
    title: "Generate Invoice",
    description:
      "Select the payment method to use, then click the 'Generate Invoice' button",
    "text.biaya": "UKT Fee",
    "text.biayaIpi": "IPI Fee",
    "text.biayaTotal": "Total Fee",
    "text.method": "Select Payment Method",
    "title.unpaid": "Pay UKT Invoice",
    "title.paid": "Payment Details",
    "description.unpaid":
      "Complete the UKT invoice payment before the payment deadline",
    "description.paid": "Payment has been completed.",
    "instruction.bri.1":
      "To pay via BRIVA, you must use BRI payment channels such as ATM, mobile banking, internet banking, or directly at a BRI teller.",
    "instruction.bri.2":
      "The payment procedure using BRI Virtual Account (BRIVA) can be viewed",
    "instruction.bri.3": "here",
    "instruction.bpd.1":
      "UKT and other official fee payments can be made through all BPD Bali Bank channels such as BPD Bali Mobile, BPD Bali Bank Internet Banking Business, BPD Bali Bank Teller, and BPD Bali Balipay by entering the 'Payment Code'.",
    "instruction.bpd.2":
      "UKT and other official fee payments using a BPD Bali Bank ATM card at BPD Bali Bank ATMs can be made by entering '0935 + Payment Code'.",
    "instruction.bpd.3":
      "UKT and other official fee payments made through other banks (online transfer) can use the BPD Bali Bank Virtual Account '5382 + Payment Code'.",
    "instruction.bpd.4":
      "The procedure for payment using the BPD Virtual Account service can be seen",
    "instruction.bpd.5": "here",
    "instruction.bni.1":
      "BNI Virtual Account payments must be made through BNI payment channels: ATM, mobile banking, internet banking, or directly at a BNI teller.",
    "instruction.bni.2":
      "The payment procedure for the BNI Virtual Account service can be viewed here.",
    "instruction.bni.3": "here",
    "label.nama-tagihan": "Invoice Name",
    "label.nominal": "Amount",
    "label.kode-pembayaran": "Payment Code",
    "label.berlaku-hingga": "Valid Until",
    "label.keterangan": "Description",
    "label.status-pembayaran": "Payment Status",
  },
};
